import { WithChildren } from 'models/technical/withProps';
import React from 'react';
import styles from 'components/UI/DefaultFormUI/ControlHint/ControlHint.module.css';

const ControlHint = ({ children }: WithChildren) => (
  <div className={styles.hint}>{children}</div>
);

export default ControlHint;
